import React from "react"
import { AppLink } from "../link/AppLink"
import styles from './Card.module.css'

export const Card = (props) => {
    return <span
        className={styles.card}>
        <img
            className={styles.card__img}
            src={props.src ? props.src : require('../../../assets/korn.jpeg')} />
        <AppLink
            to={`/player/` + props.children}>
            {props.children}
        </AppLink>
    </span>
}